import { joinWithConjunction } from "../../utilities/lists";
import { EXPIRING_SOON_DAYS } from "./accountFilterHelpers";

export const FALLBACK_PLAN_DESCRIPTION =
  "Fallback plans are month-to-month plans an account switches to if they don't accept a renewal offer or switch providers after a contract expires.";

export const CONTRACT_EXPIRATION_DESCRIPTION = `Contracts ending within ${EXPIRING_SOON_DAYS.toString()} days where the customer has not accepted a renewal offer yet. Accounts that never accept one move to a fallback plan when the contract expires.`;

/**
 * Custom contract lengths saved to an account. An empty list is not an unknown:
 * it means no override, so the plan's own terms apply, and saying so beats the
 * dash a missing value would get.
 */
export function formatTermMonthOptions(options: number[]): string {
  if (options.length === 0) {
    return "Plan's standard terms";
  }

  return `${joinWithConjunction(options.map(String), "or")} months`;
}
